// @ts-nocheck
import { Link } from 'react-router-dom';
import { Stack, Center, Group } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { Alert } from '@/components/ui/feedback';
import { IconArrowLeft, IconLockOff, IconMail, IconPhone, IconShieldCheck } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function AccountLockedPage() {
  return (
    <AuthLayoutWrapper variant="gradient" gradientFrom="#ef4444" gradientTo="#dc2626" glassEffect>
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/other"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to Other Pages
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 72,
                height: 72,
                borderRadius: 18,
                backgroundColor: 'var(--mantine-color-red-light)',
              }}
            >
              <IconLockOff size={36} color="var(--mantine-color-red-6)" />
            </Center>
            <Title order={2} ta="center">Account locked</Title>
            <Text c="dimmed" size="sm" ta="center" maw={320}>
              Your account has been temporarily locked due to multiple failed login attempts.
            </Text>
          </Stack>
        </Center>

        {/* Alert */}
        <Alert color="red" variant="light" icon={<IconShieldCheck size={18} />}>
          <Text size="sm">
            For your security, we've locked your account. It will automatically unlock in 30 minutes.
          </Text>
        </Alert>

        {/* Unlock Options */}
        <Stack gap="sm">
          <Text size="sm" fw={500} ta="center">Unlock your account</Text>

          <Button
            fullWidth
            variant="light"
            color="red"
            leftSection={<IconMail size={16} />}
          >
            Send unlock link to email
          </Button>

          <Button
            fullWidth
            variant="outline"
            color="red"
            leftSection={<IconPhone size={16} />}
          >
            Verify via phone
          </Button>
        </Stack>

        {/* Help */}
        <Stack gap="xs" align="center">
          <Text size="sm" c="dimmed">
            Need help?{' '}
            <Anchor fw={500}>Contact Support</Anchor>
          </Text>

          <Group gap="xs">
            <Anchor component={Link} to="/app/demo/auth-pages/login/gradient" size="sm">
              Try logging in again
            </Anchor>
          </Group>
        </Stack>
      </Stack>
    </AuthLayoutWrapper>
  );
}
